(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boomishoppable"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var GAP = 12; // pixels between marker and card

    function initOne(root) {
      if (!root || root.__shoppableImageInit) return;
      root.__shoppableImageInit = true;

      var trigger = root.dataset.trigger || 'click';
      var popupPos = root.dataset.popupPosition || 'auto';
      var stage = root.querySelector('.shoppable-image__stage');
      if (!stage) return;

      // On touch-only devices, "hover" trigger falls back to tap-to-open.
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var effectiveTrigger = trigger === 'hover' && canHover ? 'hover' : 'click';

      var blocks = Array.prototype.slice.call(root.querySelectorAll('.shoppable-image__block'));
      var openBlock = null;
      var hoverCloseTimer = null;

      function getParts(block) {
        return {
          marker: block.querySelector('[data-hotspot]'),
          card: block.querySelector('.shoppable-image__card'),
        };
      }

      function clearHoverTimer() {
        if (hoverCloseTimer) {
          clearTimeout(hoverCloseTimer);
          hoverCloseTimer = null;
        }
      }

      function closeBlock(block) {
        if (!block) return;
        var parts = getParts(block);
        if (!parts.card) return;
        parts.card.dataset.open = 'false';
        parts.marker.setAttribute('aria-expanded', 'false');
        // Wait for fade-out, then hide for AT.
        setTimeout(function () {
          if (parts.card.dataset.open !== 'true') {
            parts.card.hidden = true;
          }
        }, 200);
        if (openBlock === block) openBlock = null;
      }

      function closeAll() {
        blocks.forEach(closeBlock);
      }

      function positionCard(block) {
        var parts = getParts(block);
        if (!parts.marker || !parts.card) return;

        var stageRect = stage.getBoundingClientRect();
        var markerRect = parts.marker.getBoundingClientRect();
        // Reset before measuring so we get natural card size.
        parts.card.style.left = '0px';
        parts.card.style.top = '0px';
        var cardRect = parts.card.getBoundingClientRect();

        var markerCenterX = markerRect.left + markerRect.width / 2 - stageRect.left;
        var markerTop = markerRect.top - stageRect.top;
        var markerBottom = markerRect.bottom - stageRect.top;

        // Decide above vs below
        var place = popupPos;
        if (place === 'auto') {
          var roomAbove = markerTop;
          var roomBelow = stageRect.height - markerBottom;
          place = roomAbove >= cardRect.height + GAP || roomAbove > roomBelow ? 'above' : 'below';
        }

        var top;
        if (place === 'above') {
          top = markerTop - cardRect.height - GAP;
        } else {
          top = markerBottom + GAP;
        }
        // Clamp vertical to stage
        top = Math.max(8, Math.min(top, stageRect.height - cardRect.height - 8));

        // Horizontal: centered on marker
        var left = markerCenterX - cardRect.width / 2;
        // Clamp to stage edges
        left = Math.max(8, Math.min(left, stageRect.width - cardRect.width - 8));

        // Also clamp to viewport (in case stage extends past viewport edge)
        var viewportLeft = stageRect.left + left;
        var viewportRight = viewportLeft + cardRect.width;
        if (viewportLeft < 8) left += 8 - viewportLeft;
        if (viewportRight > window.innerWidth - 8) {
          left -= viewportRight - (window.innerWidth - 8);
        }

        parts.card.style.left = left + 'px';
        parts.card.style.top = top + 'px';
      }

      function openBlockFn(block) {
        if (openBlock && openBlock !== block) closeBlock(openBlock);
        clearHoverTimer();

        var parts = getParts(block);
        if (!parts.marker || !parts.card) return;

        parts.card.hidden = false;
        // Force layout, then position + fade in
        // eslint-disable-next-line no-unused-expressions
        parts.card.offsetHeight;
        positionCard(block);
        parts.card.dataset.open = 'true';
        parts.marker.setAttribute('aria-expanded', 'true');
        openBlock = block;
      }

      function toggleBlock(block) {
        if (openBlock === block) {
          closeBlock(block);
        } else {
          openBlockFn(block);
        }
      }

      blocks.forEach(function (block) {
        var parts = getParts(block);
        if (!parts.marker || !parts.card) return;

        parts.marker.addEventListener('click', function (e) {
          e.stopPropagation();
          toggleBlock(block);
        });

        parts.marker.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleBlock(block);
          }
        });

        if (effectiveTrigger === 'hover') {
          parts.marker.addEventListener('mouseenter', function () {
            clearHoverTimer();
            openBlockFn(block);
          });
          parts.marker.addEventListener('mouseleave', function () {
            clearHoverTimer();
            hoverCloseTimer = setTimeout(function () {
              closeBlock(block);
            }, 220);
          });
          parts.card.addEventListener('mouseenter', clearHoverTimer);
          parts.card.addEventListener('mouseleave', function () {
            clearHoverTimer();
            hoverCloseTimer = setTimeout(function () {
              closeBlock(block);
            }, 220);
          });
        }

        var closeBtn = parts.card.querySelector('[data-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            closeBlock(block);
            parts.marker.focus();
          });
        }

        // Don't let clicks inside the card bubble to the document close handler
        parts.card.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });

      // Close on outside click
      document.addEventListener('click', function (e) {
        if (!openBlock) return;
        if (!root.contains(e.target)) {
          closeBlock(openBlock);
        }
      });

      // Close on Esc
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && openBlock) {
          var parts = getParts(openBlock);
          closeBlock(openBlock);
          if (parts.marker) parts.marker.focus();
        }
      });

      // Re-position open card on resize / image load
      function reposition() {
        if (openBlock) positionCard(openBlock);
      }
      window.addEventListener('resize', reposition);
      var bgImg = root.querySelector('.shoppable-image__bg');
      if (bgImg && bgImg.tagName === 'IMG' && !bgImg.complete) {
        bgImg.addEventListener('load', reposition);
      }
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-shoppable-image]');
      nodes.forEach(initOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    // Theme Editor hooks
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var block = e.target;
      var marker = block.querySelector('[data-hotspot]');
      if (marker) marker.click();
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      var block = e.target;
      var card = block.querySelector('.shoppable-image__card');
      if (card && card.dataset.open === 'true') {
        var marker = block.querySelector('[data-hotspot]');
        if (marker) marker.click(); // toggle closes it
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
